import { ComponentProps, FC, memo } from 'react';
import { Badge, Button, Tooltip } from 'antd';
import {
  CloudUploadOutlined,
  FileTextOutlined,
  FilterOutlined,
} from '@ant-design/icons';
import { ButtonPopup } from '../../../features/popup/ButtonPopup/ButtonPopup';
import OutgoingCallsUploadPopupAdapter from '../../../features/outgoingCalls/OutgoingCallsUploadPopup/OutgoingCallsUploadPopupAdapter';
import { usePermissions } from '../../../hooks/shared/usePermissions';
import styles from './styles.module.css';

interface Props {
  onReport: () => void;
  onToggleFilters: () => void;
  isFiltersOpen: boolean;
  isReportLoading?: boolean;
  showUpload?: boolean;
  uploadPopupComponent?: ComponentProps<typeof ButtonPopup>['PopupComponent'];
  activeFilterCount?: number;
  disabled?: boolean;
}

const JournalActionButtonsComponent: FC<Props> = ({
  onReport,
  onToggleFilters,
  isFiltersOpen,
  isReportLoading = false,
  showUpload = true,
  uploadPopupComponent = OutgoingCallsUploadPopupAdapter,
  activeFilterCount = 0,
  disabled = false,
}: Props) => {
  const { canUploadTasks } = usePermissions();

  return (
    <div className={styles.actionsRow}>
      {showUpload && canUploadTasks && (
        <Tooltip title="Загрузить задания">
          <span>
            <ButtonPopup
              title=""
              isSquared={true}
              PopupComponent={uploadPopupComponent}
              extra={{
                icon: <CloudUploadOutlined />,
              }}
              disabled={disabled}
            />
          </span>
        </Tooltip>
      )}

      <Tooltip title="Сформировать отчёт">
        <Button
          type="primary"
          className={styles.iconButton}
          onClick={onReport}
          loading={isReportLoading}
          disabled={isReportLoading || disabled}
          icon={<FileTextOutlined />}
        />
      </Tooltip>

      <Badge
        className={styles.filterBadge}
        count={activeFilterCount}
        offset={[-2, 2]}
        size="small"
      >
        <Button
          type={isFiltersOpen ? 'default' : 'primary'}
          className={styles.filterButton}
          onClick={onToggleFilters}
          icon={<FilterOutlined />}
          disabled={disabled}
        >
          Фильтры
        </Button>
      </Badge>
    </div>
  );
};

export const JournalActionButtons = memo(JournalActionButtonsComponent);
JournalActionButtons.displayName = 'JournalActionButtons';
